import * as React from 'react';
import { Box, Skeleton } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Item from '../submodules/Item';

const Categories = (props) => {

  const categoriesList = [ "Bedroom", "CAD Details", "Decor", "Doors", "Electronics", "Exterior", "Furniture", "HVAC", "Kitchen / Dining", "Lights", "Plumbing", "Textures", "Windows", "Catalog", ]

  return (
    <Box>
      {
        categoriesList.map(category => (
          <Accordion key={category} sx={{my: .5,}}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={category + "-content"}
              id={category + "-header"}
            >
              <Typography variant="h2" fontSize={20} fontWeight="bold">{category}</Typography>
            </AccordionSummary>
            {
              props.items.length === 0 ? (
                <Skeleton variant="rectangular" sx={{display: "flex", flex: 1,}} height={414} />
              ) : (
                <AccordionDetails>
                  <Box>
                    <Box sx={{display: "flex", flexWrap: "wrap",}}>
                      {props.items.filter(item => item.category === category).map(item => (
                        <Item key={item.id} item={item} />
                      ))}
                    </Box>
                  </Box>
                </AccordionDetails>
              )
            }
          </Accordion>
        ))
      }
    </Box>
  );
}
export default Categories;